import { PageGifStatus } from '@distribute/shared/types';
import { pagesApi } from '../../../shared/api';

import { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { snackbarModel } from '../../snackbar';
import { createNotification } from '../../snackbar';

type UseGeneratePageGifProps = {
  pageId: string;
  onGenerated: () => void;
};

export const useGeneratePageGif = ({
  pageId,
  onGenerated,
}: UseGeneratePageGifProps) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handleGeneratePageGif = useCallback(() => {
    setIsLoading(true);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      return;
    }

    let cancelled = false;

    const handleFetch = () => {
      pagesApi
        .generatePageGif(pageId)
        .then((res) => {
          if (cancelled) {
            return;
          }

          if (res.status === PageGifStatus.GENERATED) {
            setIsLoading(false);
            onGenerated();
            return;
          }

          if (res.status === PageGifStatus.PENDING) {
            return;
          }
        })
        .catch(() => {
          dispatch(
            snackbarModel.actions.addNotificationAction(
              createNotification('error', 'Failed to generate page gif')
            )
          );
          setIsLoading(false);
        });
    };

    const ref = setInterval(() => handleFetch(), 1_500);
    handleFetch();

    return () => {
      cancelled = true;
      clearInterval(ref);
    };
  }, [dispatch, isLoading, pageId, onGenerated]);

  return {
    isPageGifLoading: isLoading,
    handleGeneratePageGif,
  };
};
